<template>
  <div class="container">
    <el-container>
      <el-aside width="230px" class="aside">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-vertical"
          @select="handleAsideSelect"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b"
        >
          <el-sub-menu
            v-for="menu in formattedMenus"
            :key="menu.menu_index"
            :index="menu.menu_index"
          >
            <template #title>
              <!-- 使用 component :is 来动态渲染图标 -->
              <el-icon>
                <component :is="icons[menu.menu_icon]" />
              </el-icon>
              <span>{{ menu.title }}</span>
            </template>
            <el-menu-item
              v-for="item in menu.children"
              :key="item.menu_index"
              :index="item.menu_index"
              @click="navigateTo(item.path)"
            >
              <!-- 使用 component :is 来动态渲染图标 -->
              <el-icon>
                <component :is="icons[item.menu_icon]" />
              </el-icon>
              {{ item.title }}
            </el-menu-item>
          </el-sub-menu>
        </el-menu>
      </el-aside>
      <el-container>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { ElMessageBox, ElMessage } from 'element-plus';
import axios from 'axios';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';

export default {
  name: 'HomePage',
  components: {
    ...ElementPlusIconsVue,
  },
  data() {
    return {
      activeIndex: '1',
      menus: [],
      icons: ElementPlusIconsVue,
      systemTitle: '', // 存储系统标题
      logoSrc: '', // Logo图片的URL
    };
  },
  computed: {
    formattedMenus() {
      const menus = this.menus.reduce((acc, cur) => {
        if (!cur.father) {
          acc[cur.menu_index] = { ...cur, children: [] };
        } else {
          acc[cur.father].children.push(cur);
        }
        return acc;
      }, {});
      return Object.values(menus);
    },
  },
  methods: {
    fetchMenus() {
      axios.get('/api/menus')
        .then(response => {
          this.menus = response.data;
        })
        .catch(error => {
          console.error("There was an error fetching the menus:", error);
        });
    },
    navigateTo(path) {
      if (path) {
        this.$router.push(path);
      }
    },
    handleAsideSelect(selectedIndex) {
      console.log("Selected index:", selectedIndex);
    },
    confirmLogout() {
      ElMessageBox.confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.post('/api/logout')
          .then(response => {
            if (response.data.success) {
              ElMessage({
                type: 'success',
                message: '退出登录成功',
              });
              this.$router.push('/login');
            } else {
              ElMessage({
                type: 'error',
                message: '退出登录失败',
              });
            }
          })
          .catch(() => {
            ElMessage({
              type: 'error',
              message: '退出登录失败',
            });
          });
      }).catch(() => {
        // 取消操作
      });
    },
    fetchSystemTitleAndLogo() {
      // 获取系统标题
      axios.get('/api/system-title').then(response => {
        this.systemTitle = response.data.title;
        document.title = this.systemTitle; // 设置页面标题为系统标题
      }).catch(error => {
        console.error('Error fetching system title:', error);
      });

      // 获取Logo并更新Favicon
      axios.get('/api/logo', { responseType: 'blob' }).then(response => {
        const logoUrl = URL.createObjectURL(response.data);
        this.logoSrc = logoUrl;
        this.updateFavicon(logoUrl); // 更新favicon
      }).catch(error => {
        console.error('Error fetching logo:', error);
      });
    },
    updateFavicon(logoUrl) {
      let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = logoUrl;
      document.getElementsByTagName('head')[0].appendChild(link);
    },
  },
  mounted() {
    this.fetchMenus();
    this.fetchSystemTitleAndLogo(); // 在组件加载时获取系统标题和Logo
  }
};
</script>

<style scoped>
.container {
  display: flex;
  height: 100vh;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.el-container {
  height: 100%;
  width: 100%;
}

.aside {
  height: 100%;
  overflow: auto; /* 允许滚动 */
}

.el-menu-vertical {
  height: 100%;
  overflow: auto; /* 允许滚动 */
}

.main {
  flex: 1;
  padding: 20px;
}
</style>
